// WorkExperience Component
import React, { useEffect, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import YearSelect from "components/Select/Years";
import Label from "components/Common/Label/Label";
import SearchFilterDropdown, {
  OptionType,
} from "components/Common/SearchableDropdown/SearchFilterDropdown";
import { useDebounce } from "utils";
import { getJobTitleResult } from "api/search.api";
import { Button } from "antd";
import { SmallTitle } from "components/Common/Typography/Titles";
import { SvgIcons } from "Icon/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { addMinExp, addMaxExp } from "store/slices/searcSlice"; // Ensure you have this imported
import { RootState } from "store/store";
import { useAppSelector } from "hooks/reduxHooks";

interface AddExperienceProps {
  isModal?: boolean;
  searchId?: string | null;
}

const WorkExperience:React.FC<AddExperienceProps> = ({isModal, searchId}) => {
  const dispatch = useDispatch();
  const [allJobTitles, setAllJobTitles] = useState<OptionType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // const minExp = useSelector((state: RootState) => state.search.min_exp);
  // const maxExp = useSelector((state: RootState) => state.search.max_exp);
  const selectedProject = useAppSelector((state: any) => state.search?.selectedProjectFromSearch);
  const minExp = useSelector((state: RootState) => state.search.min_exp);
  const maxExp = useSelector((state: RootState) => state.search.max_exp);
  
  // console.log(maxExp, "maxExpmaxExpmaxExpmaxExpmaxExpmaxExp");
  useEffect(() => {
    if (selectedProject &&  !isModal && !searchId) {
      dispatch(addMinExp(selectedProject.min_experience || 0));
      dispatch(addMaxExp(selectedProject.max_experience || 60));
    }
  }, [selectedProject]);

  const fetchJobTitles = async (query: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getJobTitleResult(query);
      const data: string[] = response;
      setAllJobTitles(data.map((title) => ({ value: title, label: title })));
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedSearchSkill = useDebounce((query: string) => {
    fetchJobTitles(query);
  }, 300);

  const handleInputChange = (inputValue: string) => {
    debouncedSearchSkill(inputValue);
  };

  const handleYearChange = (type: "min" | "max") => (selectedOption: any) => {
    console.log("Selected Options: ", selectedOption, type);
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      if (type === "min") {
        dispatch(addMinExp(selectedValue));
        if (selectedValue > maxExp) {
          dispatch(addMaxExp(selectedValue)); // Adjusting max if it conflicts
        }
      } else {
        dispatch(addMaxExp(selectedValue));
        // Ensuring maxExp is not less than minExp by checking after dispatch
        if (selectedValue < minExp) {
          dispatch(addMinExp(selectedValue)); // Adjusting minExp if necessary
        }
      }
    }
  };

  return (
    <>
      <div className="w-1/4">
        <SectionTitleAndDescription
          title="Work experience"
          isRequiredSection={false}
          isHelpInfoReq={false}
          tooltipText="This is a Work Experience"
          description="Select the desired minimum and maximum years of experience."
        />
      </div>

      <div className="w-3/4 xl:flex grid items-center xl:gap-4 gap-5">
        <div className="w-full">
          <div className="flex items-center gap-4">
            <div className="w-full">
              <Label
                labelTitle={"Years min"}
                isHelpIconRequired={false}
              />
              <div className="mt-1.5 SelectProject-input">
                <YearSelect value={minExp} onSelect={handleYearChange("min")} />
              </div>
            </div>

            <div className="w-full">
              <Label
                labelTitle={"Maximum years"}
                isHelpIconRequired={false}
              />
              <div className="mt-1.5 SelectProject-input">
                <YearSelect value={maxExp} onSelect={handleYearChange("max")} minValue={minExp} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkExperience;
